import { AxiosResponse } from 'axios';
import {
  SET_ORGANIZATIONS,
  SET_ORGANIZATION,
  SET_ERRORMSG,
  SET_ACCOUNT,
} from '@/store/mutation_types';
import {
  CLEAR_ORGANIZATION_ISLOADING,
  DELETE_ORGANIZATION,
  EDIT_ORGANIZATION,
  EDIT_YURTZEITEN_DISPLAY,
  GET_ORGANIZATION,
  GET_ORGANIZATIONS,
  REGISTER_ORGANIZATION,
  SIGNUP_ORGANIZATION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Organization from '@/services/organization';
import { Module } from 'vuex';
import {
  EditOrganization,
  EditYurtzeitenDisplay,
  RegisterOrganization,
  GetOrganization,
} from '@/dtos/organization.dto';

const organization: Module<any, {}> = {
  state: {
    organization: {
      data: null,
      isLoading: false,
    },
    organizations: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    organization: (state: { organization: any }) => state.organization,
    organizations: (state: { organizations: any }) => state.organizations,
  },
  mutations: {
    [SET_ORGANIZATION]: (
      state: { organization: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.organization.data = payload.data) : null,
        (state.organization.isLoading = payload.isLoading);
    },
    [SET_ORGANIZATIONS]: (
      state: { organizations: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.organizations.data = payload.data) : null,
        (state.organizations.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.registerOrganization(
        payload as RegisterOrganization
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [SIGNUP_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.signupOrganization(
        payload as RegisterOrganization
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [GET_ORGANIZATIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.getOrganizations(
        payload as GetOrganization
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATIONS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATIONS, { isLoading: false });
        return false;
      }
    },
    [GET_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.getOrganizations(
        payload as GetOrganization
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data[0],
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [EDIT_ORGANIZATION]: async (
      { commit, rootState }: any,
      payload: FormData
    ) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      let result: AxiosResponse;
      try {
        result = await Organization.editOrganization(payload);
      } catch (error) {
        // Never strand organization-backed settings in a permanent loading
        // state when the request itself rejects. Callers still receive the
        // rejection and can show their contextual error message.
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        throw error;
      }

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          rootState.account.account.data.organization = result.data.data;

          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [EDIT_YURTZEITEN_DISPLAY]: async (
      { commit, rootState }: any,
      payload: EditYurtzeitenDisplay
    ) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });
      try {
        const result: AxiosResponse = await Organization.editYurtzeitenDisplay(payload);
        if (!result?.data?.status) {
          commit(SET_ORGANIZATION, { data: null, isLoading: false });
          if (result?.data?.msg) commit(SET_ERRORMSG, result.data.msg);
          return false;
        }

        const updatedOrganization = result.data.data;
        commit(SET_ORGANIZATION, {
          data: updatedOrganization,
          isLoading: false,
        });
        if (rootState.account?.account?.data) {
          rootState.account.account.data.organization = updatedOrganization;
        }
        return true;
      } catch (error) {
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        throw error;
      }
    },
    [DELETE_ORGANIZATION]: async ({ commit }: any, payload: string) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse =
        await Organization.deleteOrganization(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ORGANIZATION_ISLOADING]: ({ commit }) => {
      commit(SET_ORGANIZATION, { isLoading: false });
      commit(SET_ORGANIZATIONS, { isLoading: false });
    },
  },
};

export default organization;
